<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body" style="margin-top: -10px">
        <div class="ppl-container">
            <div class="ppl-content-container">
                @if(!isAddDomain && !isAddLookup) {
                <div class="action add-btn">
                    <ppl-button label="Add New Domain" icon="fa fa-plus" [customClass]="'primary-button'"
                        [iconPosition]="'left'" (click)="onAddDomain()" style="margin-right: 8px;"></ppl-button>
                    <ppl-button label="Add New Lookup" icon="fa fa-plus" [customClass]="'primary-button'"
                        [iconPosition]="'left'" (click)="onAddLookupValue()"></ppl-button>
                </div>
                <div class="w-100">
                    <ppl-config-filter (searchEvent)="onSearch($event)" [filterFields]="fields"
                        [billingPageName]="'claims'"></ppl-config-filter>
                </div>

                <div class="table-style">
                    @if(configList.length > 0) {
                    <ppl-list-table [customDataLoaded]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [cols]="cols" [enableActions]="false" [data]="configList" (rowDetailEvent)="rowClicked($event)"
                        (rowDetailEventTs)="rowClickedTs($event)" [disableSelection]="true" [gridTitle]="false"
                        [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)" [from]="'billing'">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
                }
                @else if((!isAddDomain && isAddLookup) || isEditLookup) {
                <div style="width: 100%;">
                    <ppl-add-lookup-value [isEditLookup]="isEditLookup"
                        (cancel)="cancelLookup($event)"></ppl-add-lookup-value>
                </div>
                }
                @else {
                <div style="width: 100%;">
                    <ppl-add-domain [isDomainNew]="isDomainNew" (cancel)="cancelAdd($event)"></ppl-add-domain>
                </div>
                }

            </div>
        </div>
    </div>
    }

</ng-container>